import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigStateService } from '@abp/ng.core';

/** Blocks the ABP host user from a route reserved for tenants, redirecting home. */
export const hostBlockedGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const tenantId = configState.getDeep('currentUser.tenantId');
  const isHost = tenantId == null;

  if (isHost) {
    return router.createUrlTree(['/']);
  }

  return true;
};
